import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './style.css';

// eslint-disable-next-line react/prefer-stateless-function
class TextMessageItem extends Component {
  render() {
    const { message } = this.props;
    return (
      <React.Fragment>
        <a
          href=""
          className="media-left"
          onClick={e => {
            e.preventDefault();
          }}
        >
          <img
            alt=""
            className="media-object avatar avatar-sm"
            src={message.image}
          />
        </a>
        <div className="media-body media-middle full-width">
          <div className="media-info">
            <a
              href=""
              className="media-info-name"
              onClick={e => {
                e.preventDefault();
              }}
            >
              {message.username}
            </a>
            <span className="media-info-desc">
              {message.createdAtFormatted}
            </span>
          </div>
          <div className="media-content-data">{message.messageContent}</div>
        </div>
      </React.Fragment>
    );
  }
}

TextMessageItem.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    senderId: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    createdAtFormatted: PropTypes.string.isRequired,
    messageContent: PropTypes.string.isRequired
  }).isRequired
};

export default TextMessageItem;



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomMainBlock/_messages/TextMessageItem.js